import {
  ContactsOutlined,
  EuroOutlined,
  FileTextOutlined,
  GiftOutlined,
  GlobalOutlined,
  GroupOutlined,
  LineChartOutlined,
  NotificationOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import urls from "urls";

const shopNavTree = [
  {
    key: "shop",
    title: "shop",
    breadcrumb: false,
    submenu: [
      {
        key: "shop-reports",
        path: urls.reports,
        title: "reports",
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-products",
        title: "products",
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-products-productList",
            path: urls.productList,
            title: "products",
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "shop-products-addProduct",
            path: urls.addProduct,
            title: "add_product",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-products-editProduct",
            path: urls.editProduct,
            title: "edit_product",
            icon: "",
            breadcrumb: false,
            submenu: [],
            hidden: true,
          },
          {
            key: "shop-products-stock",
            path: urls.stock,
            title: "stock",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-products-forecast",
            path: urls.forecast,
            title: "forecast",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-products-price-lists",
            path: urls.priceLists,
            title: "price_lists",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-discount",
        title: "discounts",
        icon: GiftOutlined,
        breadcrumb: false,
        path: urls.discountCodes,
        submenu: [],
      },
      {
        key: "acquisition",
        title: "acquisition",
        icon: ContactsOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "leads",
            path: urls.acquisitionLeads,
            title: "leads",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shipments",
            path: urls.acquisitionShipments,
            title: "shipments",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "chat",
        title: "chat",
        icon: WhatsAppOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "chat-page",
            path: urls.chat,
            title: "chat",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "context-management",
            path: urls.chatContextManagement,
            title: "context_management",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "chat-settings-whatsapp-templates",
            title: "whatsapp_templates",
            path: urls.whatsappTemplates,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-orders",
        title: "order.orders",
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-orders-chefs-farm",
            path: urls.chefsFarmList,
            title: "chefs_farm",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-orders-growy",
            path: urls.growyList,
            title: "growy",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-orders-orderpicking-chefs-farm",
            path: "/cms/orders/orderpicking/chefs-farm",
            title: "orderpicking_chefs_farm",
            icon: "",
            breadcrumb: false,
            submenu: [],
            mobileOnly: true,
          },
          {
            key: "shop-orders-orderpicking-growy",
            path: "/cms/orders/orderpicking/growy",
            title: "orderpicking_growy",
            icon: "",
            breadcrumb: false,
            submenu: [],
            mobileOnly: true,
          },
        ],
      },
      {
        key: "shop-finance",
        title: "finance",
        icon: EuroOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-invoices-chefs-farm",
            path: urls.chefsFarmInvoiceList,
            title: "invoices_chefs_farm",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-invoices-growy",
            path: urls.growyInvoiceList,
            title: "invoices_growy",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-complaints-chefs-farm",
            path: urls.chefsFarmComplaintList,
            title: "complaints_chefs_farm",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-complaints-growy",
            path: urls.growyComplaintList,
            title: "complaints_growy",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-companies",
        title: "companies",
        icon: ShopOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-companies-existing",
            path: urls.customerList,
            title: "customers_all",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-companies-exact",
            path: urls.exactCustomerList,
            title: "exact_customers",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-companies-pending",
            path: urls.customerListPending,
            title: "customers_pending",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-notifications",
        path: urls.notifications,
        title: "notifications_title",
        icon: NotificationOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-customers",
        title: "users",
        icon: SolutionOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-users",
            path: urls.userList,
            title: "shop_users",
            icon: UserOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-admin",
            path: urls.adminList,
            title: "admin_users",
            icon: UserOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-groups",
        path: urls.groups,
        title: "groups",
        icon: GroupOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "shop-countries",
        path: urls.countryList,
        title: "countries.title",
        icon: GlobalOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-edi-log",
        path: urls.ediLog,
        title: "edi_log",
        icon: "",
        breadcrumb: false,
        submenu: [],
        // Niet in het menu (bereikbaar via /cms/edilog), wel een recht per admin.
        hidden: true,
      },
    ],
  },
];

const navigationConfig = [...shopNavTree];

export default navigationConfig;
